import React from 'react';
import { Box, Step, StepLabel, Stepper, Typography } from '@mui/material';

const steps = ['Quote', 'Details', 'Confirm', 'Pay'];

const ProgressBar = ({ currentStep }) => {
  return (
    <Box sx={{ width: '100%', marginTop: 2 }}>
      <Stepper activeStep={currentStep - 1} alternativeLabel>
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel sx={{
              '& .MuiStepIcon-root': {
                color: currentStep > index + 0 ? '#349ACE' : '#C6E1EA', // Circle color
              },
              '& .MuiStepIcon-text': {
                fill: currentStep > index + 1 ? '#fff' : '#fff', // Text inside circle
              },
            }} >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: currentStep === index + 1 ? 'bold' : 'regular',
                  color: currentStep === index + 1 ? '#349ACE' : '#6c757d',
                }}
              >
                {label}
              </Typography>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default ProgressBar;
